export default __webpack_public_path__ + "static/media/gallery-runes_00.efe06e7b.jpg";